import { Button, Modal } from 'antd';
import { useStore } from 'zustand';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import { inventoryStore } from '../../InventoryStore';
import { useInventoryActions } from '../../_components/Header/InventoryHeader/hooks/useInventoryActions';

import styles from './ChangesModal.module.scss';

type ModalFooterProps = {
  onCancel: () => void;
  onDiscardAndSwitch: () => void;
  onSaveAndSwitch: () => void;
};

const ModalFooter = ({
  onCancel,
  onDiscardAndSwitch,
  onSaveAndSwitch,
}: ModalFooterProps) => (
  <div className={styles.footerButtons}>
    <div>
      <Button key="cancel" onClick={onCancel}>
        Cancel
      </Button>
    </div>
    <div>
      <Button key="cancel" onClick={onDiscardAndSwitch}>
        Discard & Switch
      </Button>
      <Button key="save" type="primary" onClick={onSaveAndSwitch}>
        Save & Switch
      </Button>
    </div>
  </div>
);

export const ChangesModal = () => {
  const changesModalVisibility = useStore(
    inventoryStore,
    (state) => state.changesModalData
  );

  const setChangesModalVisibility = useStore(
    inventoryStore,
    (state) => state.setChangesModalData
  );

  const changeTab = useStore(inventoryStore, (state) => state.changeTab);
  const packType = useStore(inventoryStore, (state) => state.packType);
  const form = useStore(inventoryStore, (state) => state.form);
  const { onSave } = useInventoryActions();

  const closeModal = () => setChangesModalVisibility?.({ isVisible: false });

  const switchToTab = () => {
    if (changesModalVisibility?.tabSelect) {
      changeTab({ name: changesModalVisibility.tabSelect });
      amplitudeTrack('Click Inventory tab', {
        tab: changesModalVisibility.tabSelect,
        tabType: packType,
      });
    }
  };

  const onDiscardAndSwitch = () => {
    form?.resetFields();
    switchToTab();
    closeModal();
  };

  const onSaveAndSwitch = async () => {
    await onSave();
    switchToTab();
    closeModal();
  };

  return (
    <Modal
      className={styles.changesModal}
      open={changesModalVisibility.isVisible}
      title="Unsaved changes"
      okText="Save & Switch"
      cancelText="Cancel"
      onCancel={closeModal}
      footer={
        <ModalFooter
          onCancel={closeModal}
          onDiscardAndSwitch={onDiscardAndSwitch}
          onSaveAndSwitch={onSaveAndSwitch}
        />
      }
    >
      <p>Your changes will be lost if you switch tabs without saving.</p>
      <p>Do you want to save before switching tabs?</p>
    </Modal>
  );
};
